import React from "react";
import styles from "./shot-map-goal-view.module.scss";
import classNames from "classnames";
import {PenaltiesBallMissedRequestParams} from "../../../icons/images/penalties/penalties.ball-missed.request-params";
import {ShotMapBallRequestParams} from "../../../icons/shot-map/shot-map.ball.request-params";
import {useThemeColor} from "../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../app/consts/colors";
import {SVGImage} from "../../image/svg-image";
import {THEME} from "../../../app/consts";

export const ShotMapGoalViewBall = ({game, event, onChange}) => {
  if (!event.x){
    return null;
  }

  const {x, y, isActive, isGoalType, isOwnGoalShot, isBlockedShot} = event;
  const color: String = game ? (event.isHomeCompetitor ? game?.homeCompetitor.color : game?.awayCompetitor.color) : null;
  const shouldRenderCompetitorColor: Boolean = game && !isGoalType;
  const isGameShotGoal: Boolean = game && isGoalType;

  const shotProps = {
    className: classNames(styles.shot_mark,
      {[styles.active]: isActive && !shouldRenderCompetitorColor,
        [styles.missed]: !isGoalType,
        [styles.own_goal]: isOwnGoalShot,
        [styles.game_shot]: shouldRenderCompetitorColor,
        [styles.game_shot_goal]: isGameShotGoal,
        [styles.clickable]: !isActive
      }),
    style: {left: x, bottom: -y, borderColor: color},
    onClick: () => onChange && onChange(event)
  }

  const imageProps = {
    className: classNames(styles.ball),
    src: isGoalType ? new ShotMapBallRequestParams() : new PenaltiesBallMissedRequestParams(),
    fillcolor: isGoalType ? useThemeColor(isOwnGoalShot ? COLORS.dangerPrimary : COLORS.textPrimary, THEME.LIGHT) : null,
    style: {
      width: isGoalType ? 10 : 12,
      height: isGoalType ? 10 : 12,
    }
  }

  const gameShotProps = {
    className: classNames(styles.ball),
    style: {
      backgroundColor: useThemeColor(COLORS.surfaceSecondary, THEME.LIGHT),
      borderColor: color,
    }
  }

  return (
    !isBlockedShot ? <div {...shotProps}>
      {
        shouldRenderCompetitorColor ? <div {...gameShotProps}/> : <SVGImage {...imageProps}/>
      }
    </div> : null
  )
}